import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import useFocusTrap from '../../hooks/useFocusTrap';
import { createModalEscapeKeyDownHandler } from '../../utils/modalEscape';
import './AddFormModal.css';

const AddFormModal = ({
  isOpen,
  title,
  onClose,
  onSubmit,
  footer,
  children,
  className = ''
}) => {
  const modalRef = useRef(null);
  const handleEscapeKeyDown = createModalEscapeKeyDownHandler(onClose);
  useFocusTrap(modalRef, isOpen, onClose);

  useEffect(() => {
    if (!isOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={`afm-overlay ${className}`.trim()}
      onClick={(e) => e.stopPropagation()}
      onWheel={(e) => e.stopPropagation()}
      onTouchMove={(e) => e.stopPropagation()}
    >
      <div
        className="afm-card"
        ref={modalRef}
        role="dialog"
        aria-modal="true"
        onKeyDown={handleEscapeKeyDown}
        onClick={(e) => e.stopPropagation()}
      >
        <form className="afm-form" onSubmit={onSubmit}>
          <div className="afm-head">
            <h5 className="afm-title">{title}</h5>
            <button type="button" className="afm-close" onClick={onClose}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="afm-body">{children}</div>
          <div className="afm-foot">{footer}</div>
        </form>
      </div>
    </div>
  );
};

export default AddFormModal;
